/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Created_TodayInputs */

const en_task_created_today = /** @type {(inputs: Task_Created_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created today`)
};

const pt_br2_task_created_today = /** @type {(inputs: Task_Created_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado hoje`)
};

/**
* | output |
* | --- |
* | "Created today" |
*
* @param {Task_Created_TodayInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_created_today = /** @type {((inputs?: Task_Created_TodayInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Created_TodayInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_created_today(inputs)
	return pt_br2_task_created_today(inputs)
});